var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('card',{attrs:{"title":'404 - ' + _vm.$T('page not found'),"title-color":"highlight","title-inverted":""}},[_c('div',{staticClass:"q-pa-xl text-center"},[_c('v-button',{attrs:{"to":{ name: 'welcome' },"outline":"","color":"highlight","label":_vm.$T('go home')}})],1)])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe00c826","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/errors/404.vue
// module id = ifA8
// module chunks = 83